import { findRouteMeta } from '@/lib/routeRegistry';

/**
 * Page-aware quick actions for the Ask Cannafax opening screen.
 * Falls back to general starters when the route has no tailored set.
 */

const GENERAL: string[] = [
  'How do I create a menu?',
  'How do I import inventory?',
  'How do I share with buyers?',
  'What analytics are available?',
];

const BY_ROUTE: Record<string, string[]> = {
  '/my-listings': [
    'How do I bulk import inventory from Excel?',
    'How do I ask suppliers to update their inventory?',
    "What does the \"Waiting on N suppliers\" chip mean?",
    'How do I attach a COA to a listing?',
  ],
  '/my-menu': [
    'How do I create a menu?',
    'How do I control what buyers can see?',
    'How do I invite buyers to a menu?',
    'What happens when I archive a menu?',
  ],
  '/my-menu/:menuId': [
    "Can I resend an invitation that hasn't been accepted?",
    "Why can't I resend this invite yet?",
    'Who at this company has access to my menu?',
    'How do I message someone who has access?',
    'How do I add these products to another menu?',
  ],
  '/supplier-menus': [
    'How do I request access to a supplier menu?',
    'How do I contact a supplier about a listing?',
    'How do I search across supplier menus?',
  ],
  '/messages': [
    'How do buyer inquiries reach me?',
    'Can buyers see my email address?',
    'How do I reply to an inquiry?',
  ],
  '/desk': [
    'How is my next move chosen?',
    'What happens when I finish Desk Setup?',
    'How do I change my morning email?',
  ],
  '/company-settings': [
    'How do I invite a team member?',
    'How do I change what my team can access?',
    'How do I update our company profile?',
  ],
  '/profile-settings': [
    'How do I change my notification preferences?',
    'How do I update my persona?',
  ],
  '/pricing': [
    'What is included in each plan?',
    'How do I upgrade my subscription?',
  ],
  '/': [
    'What does Cannafax actually do?',
    'Is my supplier information kept private?',
    'How do buyers see my menu?',
  ],
};

export interface PageSuggestions {
  /** Human title of the current page, when known. */
  pageTitle?: string;
  questions: string[];
}

export function getPageSuggestions(pathname: string): PageSuggestions {
  const meta = findRouteMeta(pathname);

  const exact = BY_ROUTE[pathname];
  if (exact) return { pageTitle: meta?.title, questions: exact };

  const prefixKey = Object.keys(BY_ROUTE).find(
    (key) => pathname === key || pathname.startsWith(`${key}/`),
  );
  if (prefixKey) return { pageTitle: meta?.title, questions: BY_ROUTE[prefixKey] };

  return { pageTitle: meta?.title, questions: GENERAL };
}